var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 56,
    viewBox: "0 0 72 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86377 2H8.77958C12.4514 2 15.3413 4.37877 15.0353 7.11564L12.2134 32.5915C11.7374 36.7608 16.1232 40.3417 21.699 40.3417H57.9077C62.8035 40.3417 67.0874 37.3235 67.4613 33.6658L69.2973 14.4822C69.7053 10.2362 65.4214 6.78312 59.7436 6.78312H15.8513",
    stroke: "white",
    strokeWidth: 3.83673,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3119 53.1564C53.6591 53.1564 55.5617 51.725 55.5617 49.9591C55.5617 48.1932 53.6591 46.7618 51.3119 46.7618C48.9646 46.7618 47.062 48.1932 47.062 49.9591C47.062 51.725 48.9646 53.1564 51.3119 53.1564Z",
    stroke: "white",
    strokeWidth: 3.83673,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1129 53.1564C26.46 53.1564 28.3627 51.725 28.3627 49.9591C28.3627 48.1932 26.46 46.7618 24.1129 46.7618C21.7657 46.7618 19.863 48.1932 19.863 49.9591C19.863 51.725 21.7657 53.1564 24.1129 53.1564Z",
    stroke: "white",
    strokeWidth: 3.83673,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6626 17.3469H67.4611",
    stroke: "white",
    strokeWidth: 3.83673,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.bdf130d63d3d7efe6685cf2457ae2d75.svg";
export { ForwardRef as ReactComponent };